module.exports = __webpack_public_path__ + "img/6.c393ed63.svg";